import { trackTealiumView } from '@/tracking'
import { stepToTrackingNameMap } from '@/stepMappings'
import { selectSteps } from '@/redux/partnerConfig/selectors'
import { getState } from '@/config/redux'

export default (newStepIndex: number) => {
  const state = getState()

  const steps = selectSteps(state)
  const pageComponentName = steps[newStepIndex]?.component
  const stepTrackingName = stepToTrackingNameMap[pageComponentName]

  if (stepTrackingName) {
    // Pushing this to the next thread, so that we can receive updated user details.
    setTimeout(() => {
      trackTealiumView({
        screen_title: stepTrackingName,
        tealium_event: stepTrackingName,
      })
    })
  }
}
